import React from "react";
import ScreenerHeader from "./ScreenerHeader";
import ScreenerFooter from "./ScreenerFooter";
import ScoreBand from "./ScoreBand";
import SubscaleList from "./SubscaleList";
import ConnectToCareForm from "./ConnectToCareForm";
import QrCode from "./QrCode";
import InsuranceLogos from "./InsuranceLogos";
import { ScreenerResult } from "./scoring";
import { AgeBand, SelectedProvider } from "../../pages/Screener";

type ResultsScreenProps = {
  readonly result: ScreenerResult;
  readonly provider: SelectedProvider;
  readonly ageBand: AgeBand;
  readonly onConnected: () => void;
  readonly onReviewWithPediatrician: () => void;
};

export default function ResultsScreen({
  result,
  provider,
  ageBand,
  onConnected,
  onReviewWithPediatrician
}: ResultsScreenProps) {
  return (
    <section className="screener-step screener-step--results" aria-label="Your results">
      <ScreenerHeader />

      <p className="screener-eyebrow">YOUR RESULTS</p>

      <ScoreBand result={result} />
      <SubscaleList result={result} />

      <div className="screener-card screener-connect-card">
        <h2 className="screener-connect__title">Connect to Manatee for child and family therapy</h2>
        <div className="screener-connect-card__body">
          <div className="screener-connect-card__form">
            <ConnectToCareForm provider={provider} result={result} ageBand={ageBand} onSubmitted={onConnected} />
            <button type="button" className="screener-secondary-link" onClick={onReviewWithPediatrician}>
              I want to talk with my pediatrician first
            </button>
          </div>
          <QrCode />
        </div>
      </div>

      <InsuranceLogos />

      <ScreenerFooter />
    </section>
  );
}
